// @core/api/endpoints/project/get_epic.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EpicResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Get epic
 * Retrieves epic details including progress metrics and item counts.
 */
export async function GetEpic(
  project_id: string,
  epic_id: string,
  options?: RequestOptions
): Promise<EpicResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/epics/:epic_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':epic_id', encodeURIComponent(epic_id));
  const requestOptions = options;
  return client.get<EpicResponse>(requestPath, { ...requestOptions });
}
